import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings,
    deleteSettings,
    clearDeleteSettings
} from '../../../actions/settings';
import { Table } from './Table'
import { documents } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';
import ConfirmModal from '../../common/ConfirmModal'
import moment from 'moment';

let Documents = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            documentToEdit: null
        }

        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addDocument = this._addDocument.bind(this);
        this._updateDocument = this._updateDocument.bind(this);

        this._onDeleteClick = this._onDeleteClick.bind(this);
        this._onDeleteCanceled = this._onDeleteCanceled.bind(this);
        this._onDeleteConfirmed = this._onDeleteConfirmed.bind(this);
    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(documents);
    }

    _onAddClick() {
        this.setState({ showAddModal: true });
    }

    _addDocument(document) {
        this.props.updateSettings(documents, document);
    }

    _onClose() {
        this.setState({
            showAddModal: false,
            documentToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(documents);
    }

    _onEditClick(document) {
        this.setState({ documentToEdit: document, showUpdateModal: true })
    }

    _updateDocument(document) {
        this.props.updateSettings(documents, document, document.Id);
    }

    _onDeleteClick(documentToDelete) {
        this.setState({ documentToDelete, confirmModalShow: true });
    }
     _onDeleteCanceled() {
        this.setState({ documentToDelete: null, confirmModalShow: false });
        this.props.clearDeleteSettings(documents);
    }

    _onDeleteConfirmed() {
        this.props.deleteSettings(documents ,{Id :this.state.documentToDelete.Id});
    }

    render() {
        const { documents: { data, fetching, deleteFetching } } = this.props;
        const { showAddModal, showUpdateModal, documentToEdit } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: documentToEdit ? documentToEdit : { IsActive: true },
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addDocument : this._updateDocument
        };
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        return (
            <Panel>
                <Panel.Heading >
                    <span>Документы для контрагентов</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body className='departments-container'>
                    <Table
                        fetching={fetching}
                        deleteFetching={deleteFetching}
                        documents={data}
                        onEdit={this._onEditClick}
                        onDelete ={this._onDeleteClick}
                        isReadOnly={isReadOnly} />
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                    {this.state.confirmModalShow &&
                        <ConfirmModal
                            onYes={this._onDeleteConfirmed}
                            onNo={this._onDeleteCanceled}
                            fetching={deleteFetching}
                            message={`Удалить документ под Id ${moment(this.state.documentToDelete.Id)}?`}
                            title="Вы уверены?"
                            show={true} />}
                </Panel.Body>
            </Panel>
        );
    }
}

Documents = connect(state => {

    return { documents: state.application.get('settings')[documents] };
}, { getSettings, updateSettings, clearUpdateSettings ,deleteSettings ,clearDeleteSettings})(Documents);

export default Documents;


// WEBPACK FOOTER //
// ./src/components/settings/documents/Documents.jsx